import { Group, type Object3D, type WebGLRenderer } from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { KTX2Loader } from 'three/addons/loaders/KTX2Loader.js';
import { MeshoptDecoder } from 'three/addons/libs/meshopt_decoder.module.js';

/** Self-hosted Basis transcoder. Never gstatic. */
export const BASIS_TRANSCODER_PATH = '/decoders/basis/';

function extrasUcx(obj: Object3D): boolean {
  const data = obj.userData as Record<string, unknown>;
  if (data.ucx) {
    return true;
  }
  const extras = data.extras;
  if (extras && typeof extras === 'object' && extras !== null && 'ucx' in extras) {
    return Boolean((extras as { ucx?: unknown }).ucx);
  }
  return false;
}

export function hideUcx(root: Object3D): void {
  root.traverse((obj) => {
    if (obj.name.startsWith('UCX_') || extrasUcx(obj)) {
      obj.visible = false;
    }
  });
}

const loader = new GLTFLoader();
loader.setMeshoptDecoder(MeshoptDecoder);

const ktx2 = new KTX2Loader();
ktx2.setTranscoderPath(BASIS_TRANSCODER_PATH);

let ktxBound = false;

/** Call once the WebGL renderer exists. Enables KTX2 GPU transcode. */
export function bindGlbDecoders(renderer: WebGLRenderer): void {
  if (ktxBound) {
    return;
  }
  ktx2.detectSupport(renderer);
  loader.setKTX2Loader(ktx2);
  ktxBound = true;
}

export function glbLoaderReady(): { meshopt: boolean; ktx2: boolean } {
  return { meshopt: true, ktx2: ktxBound };
}

export async function loadGlb(url: string): Promise<Group> {
  const gltf = await loader.loadAsync(url);
  hideUcx(gltf.scene);
  gltf.scene.userData.animations = gltf.animations ?? [];
  return gltf.scene;
}
